import { render, staticRenderFns } from "./BreadcrumbVueRouter.vue?vue&type=template&id=c42b7550&"
import script from "./BreadcrumbVueRouter.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbVueRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports